import { TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en-gb";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

const InputDatePickerComponent = ({
  disabled,
  maxDate,
  minDate,
  onChange,
  openTo,
  placeholder,
  value,
  views,
  disableWeekends = false,
  limitToFiveYears = false,
  defaultCalendarMonth,
}) => {
  const [date, setDate] = useState(value);
  const [isDisabled, setDisabled] = useState(disabled);
  const [isPickerOpen, setPickerOpen] = useState(false);

  useEffect(() => setDisabled(Boolean(disabled)), [disabled]);

  useEffect(() => setDate(value), [value]);

  const handleClick = () => isDisabled || setPickerOpen((isOpen) => !isOpen);

  const onAccept = (date) => {
    onChange(date);
  };

  const onClose = () => {
    onChange(date);
    setPickerOpen(false);
  };

  // Function to disable weekend selection with validation
  const shouldDisableDate = (date) => {
    if (!disableWeekends || !date) return false;
    const day = date.day();
    return day === 0 || day === 6; // Sunday = 0, Saturday = 6
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-gb'>
      <DatePicker
        disableOpenPicker
        disabled={isDisabled}
        inputProps={{ readOnly: true, placeholder: placeholder }}
        maxDate={maxDate}
        minDate={limitToFiveYears ? dayjs().subtract(5, 'year').startOf('year') : minDate}
        onAccept={onAccept}
        onChange={setDate}
        open={isPickerOpen}
        onClose={onClose}
        onOpen={() => setPickerOpen(true)}
        openTo={openTo}
        {...(defaultCalendarMonth && { defaultCalendarMonth })}
        shouldDisableDate={shouldDisableDate}
        {...(disableWeekends && {
          componentsProps: {
            day: {
              sx: (theme, { day }) => ({
                ...(day && (day.day() === 0 || day.day() === 6) && {
                  color: '#999 !important',
                  backgroundColor: '#f5f5f5 !important',
                  '&:hover': {
                    backgroundColor: '#f5f5f5 !important',
                  },
                  '&.Mui-selected': {
                    backgroundColor: '#f5f5f5 !important',
                  },
                  opacity: 0.5,
                  cursor: 'not-allowed !important',
                }),
              }),
            },
          },
        })}
        renderInput={(props) => (
          <TextField
            {...props}
            placeholder={placeholder}
            onClick={handleClick}
            sx={{ input: { cursor: isDisabled ? "not-allowed" : "pointer" } }}
            InputProps={{
              ...props.InputProps,
              startAdornment: (
                <img
                  className={`cursor-${
                    isDisabled ? "disabled" : "pointer"
                  } w-8 h-8 pl-3`}
                  src='/images/calendar.svg'
                  alt='Calendar'
                />
              ),
            }}
          />
        )}
        value={date}
        views={views}
      />
    </LocalizationProvider>
  );
};

export default InputDatePickerComponent;
